module.exports = __webpack_public_path__ + "static/media/logo110.c3355f8e.png";